import { Location } from '@angular/common';
import { HttpHeaders } from '@angular/common/http';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { WizardComponent } from 'angular-archwizard';
import { IMyDpOptions, IMyInputFieldChanged } from 'mydatepicker';
import { Subscription } from 'rxjs';
import { HttpClientService } from '../../Services/http-client.service';
import { SessionService } from '../../Services/session.service';
import { AppSettings } from '../../app-settings';
import { EventService } from "../../Services/event.service";




@Component({
  selector: 'app-extendCourse-subscription',
  templateUrl: './extend-course-subscription.component.html',
  styleUrls: ['./extend-course-subscription.component.css']
})
export class ExtendCourseSubscriptionComponent implements OnInit,OnDestroy {
  formValid:boolean=false;
  extendCourseValid:boolean = false;
  yesNoValidity:boolean = false;
  enterDetailsValidity:boolean = false;
  inputSecondaryAccount:boolean = false;
  repurchaseButtonDisabled:boolean = false;
  registerButtonDisabled:boolean = false;
  success_msg_pwd:boolean;
  securityForm: any;
  emailForm: any;
  isNotSameError:boolean = false;
  isNotSameEmailError:boolean = false;
  accountLinked:boolean = false;
  displayMessage:boolean = false;
  responseMessage:string="";
  newUser:string="";
  courseList:Array<any>;
  repuchaseList:Array<any>;
  active:boolean=false;
  choiceListActive:boolean = false;
  gmatDate:Date;
  date = new Date();
  courseHasDate:boolean=true;
  dateplaceHolder = "Select the Date";
  dateplcaeHolderNo = "Select the Date";
  userChoice:string="";
  buttonLabel:string="";
  buttonDurationLabel:string="";
  packageCourseName:string="";
  gmatProof:any;
  packageData: object = {};
  defaultChoice:string="Select the Course";
  subscriptionList:Array<any>;
  declarationInput:boolean=false;
  repurchaseWizard:boolean=false;
  freshCopySelected:boolean=false;
  dateInput:boolean;
  extensionPrice:any;
  actualPrice:any;
  refundPrice:any;
  extensionPeriod:any;
  extensionLink:any;
  chargeDetails:boolean=false;
  dateInvalid:boolean=true;
  hasDate:boolean=false;
  btnCaption:string="Upload";
  popup:string="";
  status:boolean=false;
  proofAttach:boolean=true;
  askGMATDate=["Yes","No"];
  formData:FormData;
  dateSelected:boolean = false;
  imageUploaded:boolean = false;
  yesNotext:string = "Yes/No";
  userNoDateSelected:boolean = false;
  userNoExtendValidity:boolean = false;
  userYesExtendValidity:boolean = false;
  courseListLoaded:boolean = false;
  extensionNoDataLoaded:boolean = false;
  extensionYesDataLoaded:boolean = false;
  rePurchaseDataLoaded:boolean = false;
  listRepurchaseErrorMessage:string;
  isListRepurchaseError:boolean = false;
  isUpdatePackageErrorNo:boolean = false;
  updatepackageErrorMessageNo:string;
  isUpdatePackageErrorYes:boolean = false;
  updatepackageErrorMessageYes:string;
  listWaiting:string = AppSettings.cdnUrl+"assets/images/list_waiting.gif";
  loadingCircleURL = AppSettings.loadingCircleImageURL;
  closeImage:string = AppSettings.cdnUrl+"assets/images/close.png";
  gmatScreenShotImg= AppSettings.cdnUrl+"assets/images/GMAT-screenshot.png";
  isExtensionListError:boolean = false;
  faqImage3:string = AppSettings.cdnUrl+"assets/images/faq_3.png";
  faqImage4:string = AppSettings.cdnUrl+"assets/images/faq_4.png";
  redirectImg = AppSettings.cdnUrl+"assets/images/blocks_redirect.gif";
  extensionListError:string;
  uploadedImageName:string;
  redirectMsg:string = '';
  redirectToCart:boolean = false;
  dateYes:any;
  dateNo:any;
  packageId:number;
  proofGMATYes:any;
  proofGMATNo:any = null;
  public myDatePickerOptions: IMyDpOptions = {
        // other options...
        dateFormat: 'dd-mmm-yyyy',
        showTodayBtn:false,
        sunHighlight:false,
        editableDateField:false,
        disableUntil:{year: this.date.getFullYear(),
            month: this.date.getMonth()+1,
            day: this.date.getDate()},
            disableSince:{year: this.date.getFullYear(),
            month: this.date.getMonth(),
            day: this.date.getDate() + 217},
            ariaLabelInputField:'Select the Date',
            alignSelectorRight:true,
            openSelectorOnInputClick:true
  };
 expand:string=AppSettings.cdnUrl+"assets/images/expandArrow.png";
 collapse:string=AppSettings.cdnUrl+"assets/images/collapse.png";
 dataAvailable:boolean=false;
 extensionActionConfig:object={
   "extend":"EXTENSION",
   "repurchase":"REPURCHASE"
 };
 extensionAction:String="";
 showHaveGMATDateContainer:boolean=true;
 selectedOffer:boolean=false;
 extensionOffers={};
 gmatDateTimestamp:any;
 userInfoSubscription:Subscription;
 fullName:string='';
 userName:string='';
 gmatEventDate:any;
 extensionsLoaded:boolean=false;
 selectedOfferIndex:number;
 packageName:string="";
 purchaseOffer:any;
 extendNowFlag:boolean=false;
 paymentResponseSubscription:Subscription;
 paymentResponse:any;
 paymentResponseExist:boolean = false;
 paymentIntentCreationError:boolean = false;
 backButtonURL:string = AppSettings.cdnUrl + 'assets/images/back_button.png';
 @ViewChild(WizardComponent, { static: false })
public wizard: WizardComponent;

/*sampleData = {
	"GMAT Live" : [
		{
			"duration": "1 month",
			"price": 89.0,
			"extensionLink": "https://e-gmat.com/secure/cart/?q=cart/add/p197_q1_a5o18",
			"packageName": "GMAT Live",
			"productId": 555
		},
		{
			"duration": "2 month",
			"price": 269.0,
			"extensionLink": null,
			"packageName": "GMAT Live",
			"productId": 558
		}
	],
	"GMAT Focus" : [
		{
			"duration": "1 month",
			"price": 79.0,
			"extensionLink": "https://e-gmat.com/secure/cart/?q=cart/add/p197_q1_a5o18",
			"packageName": "GMAT Focus",
			"productId": 555
		},
		{
			"duration": "4 month",
			"price": 229.0,
			"extensionLink": null,
			"packageName": "GMAT Focus",
			"productId": 558
		}
	],
	"Live Sessions" : [
		{
			"duration": "1 month",
			"price": 49.0,
			"extensionLink": "https://e-gmat.com/secure/cart/?q=cart/add/p197_q1_a5o18",
			"packageName": "Live Session",
			"productId": 555
		}
	]
}*/
	

  constructor(private formbuilder:FormBuilder,private httpClientService: HttpClientService, private sessionService:SessionService, private sanitizer: DomSanitizer,private router:Router, private route:ActivatedRoute, private readonly location: Location, private eventService: EventService)
 {
   this.securityForm = formbuilder.group({
     'newEmail': ['', [Validators.required,Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$')]],
     'newpwd':['', [Validators.required, Validators.minLength(6),Validators.pattern('^\\S*$')]],
     'cnfpwd':['', [Validators.required, Validators.minLength(6),Validators.pattern('^\\S*$')]]
   });
   this.emailForm = formbuilder.group({
     'newRegEmail': ['', [Validators.required,Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$')]],
     'cnfRegEmail': ['', [Validators.required,Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$')]],

   });
 }

get newEmail() { return this.securityForm.get('newEmail'); }
get newpwd() { return this.securityForm.get('newpwd'); }
get cnfpwd() { return this.securityForm.get('cnfpwd'); }
get newRegEmail() { return this.emailForm.get('newRegEmail'); }
get cnfRegEmail() { return this.emailForm.get('cnfRegEmail'); }

  ngOnInit()
  {
    this.getPackageId();
    this.getFullName();
    this.subscribeToPaymentResponse();
  }
  getFullName()
  {

    this.userInfoSubscription = this.sessionService.getUserInfo$.
    subscribe(data => {
		 if(data != "")
		 {
	     this.fullName = data.firstName +' '+data.lastName;
       this.userName = data.username;
	 	 }
      });

   }
  getPackageId()
  {
    this.route.params.subscribe(params => {
      if(params)
      {
        let config = JSON.parse(atob(params['config']));
        this.packageId = parseInt(config['packageId']);
        this.extensionAction = config['extensionAction'];
        this.buttonLabel = config['buttonLabel'];
        if(this.extensionAction=="EXTENSION")
        {
          this.repurchaseWizard = false;
        }
        else if(this.extensionAction=="REPURCHASE")
        {
          this.buttonDurationLabel = config['buttonDurationLabel'];
          console.log("button duration label :"+ this.buttonDurationLabel);
          this.repurchaseWizard = true;
        }

        this.dataAvailable=true;
      }
    });
  }
  subscribeToPaymentResponse()
  {
    this.paymentResponseSubscription = this.sessionService.sharedPaymentResponse.subscribe((data)=>{
      if(data)
      {
        this.paymentResponse = data;
        this.paymentResponseExist=true;
      }
      else
      {
        this.paymentResponse = '';
        this.paymentResponseExist=false;
      }
    });
  }
selectOffer(event,index,name)
{
  console.log(index);
  this.selectedOfferIndex = index;
  this.extensionOffers["GMAT Live"].forEach((item)=>{
    item['selected']=false;
  });
  this.extensionOffers["GMAT Focus"].forEach((item)=>{
    item['selected']=false;
  });
  this.extensionOffers["Live Sessions"].forEach((item)=>{
    item['selected']=false;
  });
  this.extensionOffers[name][index]['selected']=true;
  this.purchaseOffer = this.extensionOffers[name][index];
  this.packageName = this.extensionOffers[name][index]["packageName"];
  this.selectedOffer = true;
}
extendCourse(stepIndex:number)
{
  // let extensionLink = this.extensionOffers[this.selectedOfferIndex]['extensionLink'];
  //
  // this.redirectMsg = 'Redirecting to Shopping cart.'
  // this.redirectToCart=true;
  // setTimeout(()=>{window.location.href = extensionLink;},2000);

  this.sessionService.sharePurchasedExtendion(this.purchaseOffer);
  this.extendNowFlag = true;
  let packageID = this.purchaseOffer['productId'];
  this.saveOrderAndCreatePaymentIntent(packageID, stepIndex);
}
repurchaseCourse(){
  this.fetchProductDetails();
}

fetchProductDetails(){
  let productInfo = {
    'productId': this.packageId
  };
  this.httpClientService.post(AppSettings.restApiUrl+'/api/package/fetchPackage', productInfo, new HttpHeaders()).subscribe((data)=>{
    if(data){
      this.purchaseOffer = data;
      this.sessionService.sharePurchasedExtendion(this.purchaseOffer);
      this.sessionService.shareAlternateUser(this.newUser);
      this.extendNowFlag = true;
      let packageID = this.packageId;
      this.packageName = data.packageName.replace("Repurchase", "").trim();
      this.saveOrderAndCreatePaymentIntent(packageID);
    }
  },
  (e)=>{
      console.log("error occured:"+e.toString());
  });
}
toggleAccounts(){
  this.accountLinked = false;
  this.newUser = "";
  this.repurchaseButtonDisabled = true;
  this.registerButtonDisabled = false;
  this.displayMessage= false;

  if(  this.inputSecondaryAccount)
    this.inputSecondaryAccount = false;
  else
    this.inputSecondaryAccount = true;
}
checkPassword()
{
      if(this.newpwd.value != this.cnfpwd.value)
      {
          this.isNotSameError = true ;
      }
      else
      {
          this.isNotSameError = false;
      }
}
checkEmail(){
      if(this.newRegEmail.value != this.cnfRegEmail.value)
      {
          this.isNotSameEmailError = true ;
      }
      else
      {
          this.isNotSameEmailError = false;
      }
}
createUser(){
  let userInfo = {
    'username': this.newEmail.value,
    'password': this.newpwd.value
  };
  this.httpClientService.post(AppSettings.restApiUrl+'/api/user/createUserAccount', userInfo, new HttpHeaders()).subscribe((data)=>{
    this.displayMessage = true;
    this.responseMessage = data.message;
    if(data.success){
        this.accountLinked = true;
        this.newUser = this.newEmail.value;
        this.repurchaseButtonDisabled = false;
        this.registerButtonDisabled = true;
    }
    else{
        this.accountLinked = false;
        this.newUser = "";
        this.repurchaseButtonDisabled = true;
        setTimeout(() =>{
          this.displayMessage= false;
        },5000);
    }

  },
  (e)=>{
      console.log("error occured:"+e.toString());
  });
}
validateUser(){
  let userInfo = {
    'username': this.newRegEmail.value
  };
  this.httpClientService.post(AppSettings.restApiUrl+'/api/user/validate', userInfo, new HttpHeaders()).subscribe((data)=>{
    this.displayMessage = true;
    this.responseMessage = data.message;
    if(data.success){
        this.accountLinked = true;
        this.newUser = this.newRegEmail.value;
        this.repurchaseButtonDisabled = false;
    }
    else{
        this.accountLinked = false;
        this.newUser = "";
        this.repurchaseButtonDisabled = true;
    }
    setTimeout(() =>{
      this.displayMessage= false;
    },5000);
  },
  (e)=>{
      console.log("error occured:"+e.toString());
  });

}

saveOrderAndCreatePaymentIntent(packageID, index=0)
{
  let productInfo = {
    'productId': packageID,
    'username' : this.newUser,
    'purchaseType' : this.extensionAction
  };
  this.httpClientService.post(AppSettings.restApiUrl+'/api/create-payment-intent', productInfo, new HttpHeaders()).subscribe((data)=>{
    if(data.success)
    {
      let paymentIntentKey = data.secretKey;
      this.sessionService.sharePIKey(paymentIntentKey);
      this.wizard.navigation.goToStep(this.wizard,index);
      this.extendNowFlag=true;
    }
    else
    {
      this.paymentIntentCreationError = true;
    }
  },
  (e)=>{
    this.paymentIntentCreationError = true;
  });
}

sendSelectedCourse(event){
  this.userChoice = event.target.value;
  setTimeout(()=>{
    this.showHaveGMATDateContainer=false;
  },500);
}
selectedRepurchaseOption(event){
  if(event.target.value == "Yes"){
    this.repurchaseButtonDisabled = true;
    this.freshCopySelected = true;
  }
  else{
      this.freshCopySelected = false;
      this.repurchaseButtonDisabled = false;
      this.accountLinked = false;
      this.newUser = "";
  }
}

onDateChanged(event:any)
{
  this.gmatEventDate = event.date;
  this.gmatDate=event.formatted;
  this.dateplaceHolder = event.formatted;
  this.packageData["gmatDate"]=event.epoc*1000 + 86400000 - 1000;
  this.gmatDateTimestamp = event.epoc*1000 + 86400000 - 1000;
  this.dateSelected = true;
}
onInputFieldChanged(event:IMyInputFieldChanged)
{
}
gmatDateUpdate()
{
  this.enteredGMATDateEvent();
  let packageInfo = {};
  packageInfo["gmatDate"] = this.gmatDateTimestamp;
  packageInfo["packageId"] = this.packageId;
  packageInfo["extensionAction"] =this.extensionAction;
  this.extensionsLoaded = false;
  let x = this.packageData;
  const headers = new HttpHeaders();
      this.httpClientService.post(AppSettings.restApiUrl + '/api/user/gmat/date/update', packageInfo, headers)
        .subscribe(
          (data) => {
            this.extensionOffers = data;
           // this.extensionOffers = this.sampleData;

            this.extensionOffers["GMAT Live"].forEach((item,index)=>{
              item['selected']=false;
              if(this.packageName=='')
              {
                  this.packageName = item['packageName'];
              }
            });
            this.extensionOffers["GMAT Focus"].forEach((item,index)=>{
              item['selected']=false;
            });
            this.extensionOffers["Live Sessions"].forEach((item,index)=>{
              item['selected']=false;
            });
            this.extensionsLoaded=true;
          });
}
enteredGMATDateEvent()
{
  let tentativeDate = this.userChoice=="Yes"?false:true;
  let eventName ="entered gmat date";
  let gmatDate = this.gmatEventDate;
  let timestamp = new Date().getTime();
  let computed_properties = {
                              "egd_name":this.fullName,
                              "egd_gmatdate_mp":new Date(gmatDate['year'],gmatDate['month']-1,gmatDate['day']).toISOString(),
                              "egd_gmatdate":(gmatDate['month'])+'/'+gmatDate['day']+'/'+gmatDate['year'],
                              "egd_timestamp":timestamp,
                              "source_name" :"ext_flow",
                              "tentative date":tentativeDate
                                };
  this.eventService.track(eventName,computed_properties);
}
  goBack()
  {
    this.router.navigateByUrl('/user/extensions');
  }

  ngOnDestroy()
  {
    this.paymentResponse=""
    this.paymentResponseExist=false;
    this.paymentResponseSubscription.unsubscribe();
    this.userInfoSubscription.unsubscribe();
  }
}
